import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './SubAssemblyFooter.module.css';
import StatusCircle from '../StatusCircle/StatusCircle';

const SubAssemblyFooter = ({ asns = [], countData }) => {
  const dispatchedCount =
    countData?.data?.dispatched ??
    asns.filter(asn => {
      if (asn.status === 'DISPATCHED' || asn.status === 'DROPPED') return true;
      if (Array.isArray(asn.subassembly) && asn.subassembly.length > 0) {
        return asn.subassembly.some(s => s.printFlag === true || s.status === 'DISPATCHED' || s.status === 'DROPPED');
      }
      return false;
    }).length;
  const pendingCount =
    countData?.data?.pending ?? asns.length - dispatchedCount;

  return (
    <div className={styles.container}>
      <div className={styles.planCountDisplay} data-testid={'countLegends'}>
        <div>
          <span className={clsx(styles.countMetric, styles.number)}>
            {pendingCount}
          </span>
          <span className={clsx(styles.countMetric, styles.number)}>
            {dispatchedCount}
          </span>
        </div>
        <hr />
        <div>
          <span className={clsx(styles.countMetric, styles.label)}>
            Pending
          </span>
          <span className={clsx(styles.countMetric, styles.label)}>
            Dispatched
          </span>
        </div>
      </div>
      <div className={styles.legend}>
        <div className={styles.legendFlex}>
          <div className={styles.greyArea}>
            <div
              className={styles.statusLegend}
              data-testid={'trans-state-legends'}
            >
              <div className={styles.statusLegendFlex}>
                <div>
                  <StatusCircle
                    className={styles.statusCircleCustom}
                    data-testid={'dispatched'}
                    color="blue"
                  />
                  <span className={styles.statusInfoText}>Dispatched</span>
                </div>
                <div>
                  <StatusCircle
                    className={styles.statusCircleCustom}
                    data-testid={'Pending'}
                  />
                  <span className={styles.statusInfoText}>Pending</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SubAssemblyFooter.propTypes = {
  asns: PropTypes.array,
  countData: PropTypes.object,
};

export default SubAssemblyFooter;
